export enum Permission {
  PromotedPlacements = 'promoted_placements.legacy_permission',
  PromotedPlacementsManager = 'promoted_placements_manager.legacy_permission',
}
